export default __webpack_public_path__ + "static/media/collection-icon.e88a9dee.svg";